import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import {Button, MenuItem, Tooltip} from '@mui/material';

import MenuLink from './NavMenuLink.jsx';
import NavMenuButton from './NavMenuButton.jsx';
import UserAvatar from '../UserAvatar.jsx';

/**
 * A user menu for the NavBar
 */
const UserMenu = ({
  user,
  logout,
  login,
  loginText,
  children,
  showAccountLink,
  accountUrl,
}) => {
  return (
    <Fragment>
      {user ? (
        <NavMenuButton
          label={<UserAvatar user={user} size="xsmall" data-qe="menu-avatar" />}
          aria-label={`Planet Account ${user.name}`}
        >
          {showAccountLink && (
            <MenuLink
              title="Manage Account"
              component="a"
              target="_blank"
              rel="noreferrer noopener"
              href={accountUrl}
              data-qe="menu-account-settings"
            >
              My Account
            </MenuLink>
          )}
          {children}
          {logout && (
            <MenuItem onClick={logout} data-qe="menu-logout">
              Log Out
            </MenuItem>
          )}
        </NavMenuButton>
      ) : (
        login && (
          <Tooltip title="Log in to your Planet account">
            <Button color="primary" onClick={login}>
              {loginText}
            </Button>
          </Tooltip>
        )
      )}
    </Fragment>
  );
};

UserMenu.propTypes = {
  /**
   The Planet user object
  */
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  /**
   Callback function called when the logout button is clicked
  */
  logout: PropTypes.func,
  /**
   Callback function called when the login button is clicked
  */
  login: PropTypes.func,
  /**
   Controls whether the link to the Account page be visible
  */
  showAccountLink: PropTypes.bool,
  /**
   Text to display on the login button
  */
  loginText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   (Additional) Contents of the user menu
  */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   Url of the Planet account app to use
  */
  accountUrl: PropTypes.string,
};

UserMenu.defaultProps = {
  loginText: 'Log In',
  showAccountLink: true,
  accountUrl: 'https://www.planet.com/account/',
};

export default UserMenu;
